/* istanbul ignore file */

type GetPolyfills = () => Promise<unknown>[];
export const getPolyfills: GetPolyfills = () => {
  const polyfills: Promise<unknown>[] = [];

  if (!('requestIdleCallback' in window) || !('cancelIdleCallback' in window)) {
    polyfills.push(
      import(/* webpackChunkName: "2-polyfill-idle" */ 'requestidlecallback').then((module) => {
        const { request: requestIdleCallback, cancel: cancelIdleCallback } = module.default;
        window.requestIdleCallback = requestIdleCallback;
        window.cancelIdleCallback = cancelIdleCallback;

        return module;
      })
    );
  }

  return polyfills;
};
